module.exports = __webpack_public_path__ + "img/bag-dash-fill.3fb59c4b.svg";